import * as React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { blankWaterMeter } from './NewWaterMeterDialog';
import { vendorWithModelOptions } from '../../pages/CrudCalyxWaterMeters';

/**
 * @type {React.FunctionComponent<{
 *   isOpen: boolean;
 *   targetWaterMeter: object;
 *   onSave?: () => void;
 *   onCancel?: () => void;
 * }>}
 */
const EditWaterMeterDialog = (props) => {
  const { isOpen, targetWaterMeter, onSave, onCancel } = props;

  const [waterMeter, setWaterMeter] = React.useState(blankWaterMeter);

  React.useEffect(() => {
    setWaterMeter(targetWaterMeter ?? blankWaterMeter);
  }, [targetWaterMeter]);

  return (
    <Dialog
      visible={isOpen}
      header={
        <>
          Edit Water Meter
        </>
      }
      footer={
        <>
          <Button label='Cancel' icon='pi pi-times' text onClick={() => onCancel()} />
          <Button label='Save' icon='pi pi-check' text onClick={() => onSave(waterMeter)} />
        </>
      }
      style={{ width: '600px' }}
      blockScroll
      onHide={() => onCancel()}
    >
      <div className="flex flex-column gap-3">
        <div className="flex flex-column gap-2">
          <label>Serial Number</label>
          <InputText
            value={waterMeter.serialNumber ?? ''}
            invalid={!waterMeter.serialNumber}
            onInput={(event) => setWaterMeter((val) => ({ ...val, serialNumber: event.target.value }))}
            disabled
          />
        </div>
        <div className="flex flex-column gap-2">
          <label>Hardware Serial</label>
          <InputText
            value={waterMeter.hardwareSerial ?? ''}
            invalid={!waterMeter.hardwareSerial}
            onInput={(event) => setWaterMeter((val) => ({ ...val, hardwareSerial: event.target.value }))}
            disabled
          />
        </div>
        <div className="flex flex-column gap-2">
          <label>Vendor with Model</label>
          <Dropdown
            value={waterMeter.vendorWithModel ?? null}
            invalid={waterMeter.vendorWithModel == null}
            options={vendorWithModelOptions}
            optionLabel="label"
            optionValue="value"
            onChange={(event) => setWaterMeter((val) => ({ ...val, vendorWithModel: event.value }))}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default EditWaterMeterDialog;
